(async function () {
  'use strict';

  async function init() {

  // Title + button text come from the customizer (block settings), passed through
  // the #complete-the-look-data JSON payload. These are fallback defaults only.
  var DEFAULT_CTA = 'Add Both To Cart';
  var SOLD_OUT_CTA = 'SOLD OUT';
  var SELECT_SIZE_CTA = 'Select Size';
  var SECTION_TITLE = 'Complete the Look';

  // Every price node carries these so the buckscc currency converter picks it up
  // and rewrites it, exactly like the theme's own .money elements.
  var MONEY_CLASS = 'money buckscc-converted buckscc-money';

  // Colour swatch click, on BOTH cards:
  //   false → navigates to that colour's PDP, same as the collection cards
  //   true  → swaps the product inside the bundle without leaving the page
  var SWAP_IN_PLACE = false;
  var SWATCH_STEP = 82;

  var PLUS_SVG =
    '<svg width="29" height="29" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">' +
    '<circle cx="14.99" cy="14.99" r="14.74" fill="white" stroke="black" stroke-width="0.5"/>' +
    '<path d="M14.798 19.394V16.048H11.452V15.404H14.798V12.058H15.442V15.404H18.788V16.048H15.442V19.394H14.798Z" fill="black"/>' +
    '</svg>';

  var QS_PLUS_SVG =
    '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
    '<line x1="12" y1="5" x2="12" y2="19"></line>' +
    '<line x1="5" y1="12" x2="19" y2="12"></line>' +
    '</svg>';
        
  var ARROW_PREV_SVG =
    '<svg width="11" height="11" viewBox="0 0 14 14" fill="none"><path d="M6.3 7l2.683 2.683L8.166 10.5 4.666 7l3.5-3.5.817.817L6.3 7z" fill="currentColor"/></svg>';
  var ARROW_NEXT_SVG =
    '<svg width="11" height="11" viewBox="0 0 14 14" fill="none"><path d="M7.7 7L5.017 9.683 5.834 10.5l3.5-3.5-3.5-3.5-.817.817L7.7 7z" fill="currentColor"/></svg>';

  var BADGES = {
    base: '<span class="ctl-bundle__badge viewing new_badge">Viewing</span>',
    paired: '<span class="ctl-bundle__badge paired new_badge">Pairs with</span>'
  };

  var section = null;
  var ctaBtn = null;
  var isAdding = false;
  var state = null;
  var swatchMap = {};
  var swapping = {};

  async function getCompleteTheLookData() {
    try {
      const dataEl = document.getElementById('complete-the-look-data');
      if (!dataEl) { console.warn('[CTL] Data element not found'); return null; }
      const rawData = dataEl.textContent?.trim();
      if (!rawData) { console.warn('[CTL] Data element is empty'); return null; }
      const data = JSON.parse(rawData);
      if (!data || typeof data !== 'object') { console.warn('[CTL] Invalid data format'); return null; }
      return data;
    } catch (error) {
      console.error('[CTL] Failed to parse data', error);
      return null;
    }
  }

  const data = await getCompleteTheLookData();
  if (!data) return;

  var baseHandle = data.base_handle;
  var pairedHandles = Array.isArray(data.paired_handles)
    ? data.paired_handles.filter(Boolean)
    : (data.paired_handle ? [data.paired_handle] : []);

  var matchingSetsUrl = data.matching_sets_url || '/collections/matching-sets';
  var matchingSetsLabel = data.matching_sets_label || 'MATCHING SETS';

  if (data.title) SECTION_TITLE = data.title;
  if (data.cta_default) DEFAULT_CTA = data.cta_default;
  if (data.cta_soldout) SOLD_OUT_CTA = data.cta_soldout;
  if (data.swatches && typeof data.swatches === 'object') swatchMap = data.swatches;

  if (!baseHandle || !pairedHandles.length) return;

  var pairedHandle = pairedHandles[0];

  Promise.all([fetchProduct(baseHandle), fetchProduct(pairedHandle)])
    .then(function (products) {
      var base = products[0];
      var paired = products[1];
      if (!isRenderable(base) || !isRenderable(paired)) return;

      state = { base: makeEntry(base, getPdpVariantId()), paired: makeEntry(paired) };
      mirrorSizeToPaired();

      console.log('[CTL] preselect', {
        pdpVariantId: getPdpVariantId() || '(not found)',
        base: state.base.variant
          ? chipLabel(state.base.variant, state.base.sizeIdx) + ' (' + state.base.variant.id + ')'
          : '(none)',
        paired: state.paired.variant
          ? chipLabel(state.paired.variant, state.paired.sizeIdx) + ' (' + state.paired.variant.id + ')'
          : '(none)'
      });

      renderBundle();
      watchPdpVariant();

      // Re-render once if a variant-switch section re-render strips the bundle.
      // Uses current state, so colour/size picks inside the bundle survive.
      var rerendering = false;
      var observerTarget = document.querySelector('main') || document.body;
      if (observerTarget && typeof MutationObserver !== 'undefined') {
        var observer = new MutationObserver(function () {
          if (rerendering) return;
          if (document.querySelector('.ctl-bundle')) return;
          rerendering = true;
          renderBundle();
          rerendering = false;
        });
        observer.observe(observerTarget, { childList: true, subtree: true });
      }
    })
    .catch(function () {});

  // ─── Data helpers ─────────────────────────────────────────────────────────

  function makeEntry(product, preselectId) {
    // The product the shopper is actually on gets its current PDP size
    // pre-selected. Everything else starts empty — they pick from the + popup,
    // and whatever they pick is the variant that goes to cart.
    var variant = null;
    if (preselectId) variant = findVariant(product, preselectId);
    // Base side: if the PDP's variant can't be resolved (theme markup differs,
    // no ?variant= in the URL), fall back to its first in-stock size so the
    // viewed product is never left without a selection.
    if (!variant && preselectId !== undefined) variant = getFirstAvailableVariant(product);
    if (!variant && !hasRealVariants(product)) variant = getFirstAvailableVariant(product);

    return {
      product: product,
      variant: variant,
      sizeIdx: getSizeOptionIndex(product),
      swatches: Array.isArray(swatchMap[product.handle]) ? swatchMap[product.handle] : []
    };
  }

  // The paired product follows the size of the product being viewed — on load
  // and every time the viewed size changes. Picking a size on the paired card
  // itself still overrides it, until the viewed size changes again.
  function mirrorSizeToPaired() {
    var paired = state.paired;
    if (!hasRealVariants(paired.product)) return;

    var baseVariant = state.base.variant;
    if (!baseVariant) return;

    var label = chipLabel(baseVariant, state.base.sizeIdx);
    var match = findVariantByLabel(paired.product, label, paired.sizeIdx);

    // Fallback: the paired product may name its size option differently, so the
    // size index doesn't line up. Match the label against any of its options.
    if (!match) {
      var want = normalizeSize(label);
      for (var i = 0; i < paired.product.variants.length; i++) {
        var v = paired.product.variants[i];
        if (!v.available || !v.options) continue;
        for (var o = 0; o < v.options.length; o++) {
          if (normalizeSize(v.options[o]) === want) { match = v; break; }
        }
        if (match) break;
      }
    }

    if (match) {
      paired.variant = match;
    } else {
      // That size doesn't exist on the paired product, or it's sold out.
      paired.variant = null;
      console.log(
        '[CTL] paired has no in-stock "' + label + '". Its sizes: ' +
        paired.product.variants
          .map(function (v) { return chipLabel(v, paired.sizeIdx) + (v.available ? '' : ' (sold out)'); })
          .join(', ')
      );
    }
  }

  // The variant the PDP itself currently has selected: ?variant= in the URL
  // first, then the add-to-cart form's hidden id input, then the Liquid payload.
  function getPdpVariantId() {
    try {
      var fromUrl = new URLSearchParams(window.location.search).get('variant');
      if (fromUrl) return fromUrl;
    } catch (e) {}

    var selectors = [
      'form[action*="/cart/add"] [name="id"]',
      'variant-selects [name="id"]',
      'variant-radios [name="id"]',
      '[data-product-form] [name="id"]',
      'product-form [name="id"]',
      '[name="id"][value]'
    ];
    for (var i = 0; i < selectors.length; i++) {
      var el = document.querySelector(selectors[i]);
      if (el && el.value) return el.value;
    }

    return data.selected_variant_id || '';
  }

  // Shopper changes size on the PDP → the "Viewing" card follows along. Only
  // fires when the PDP value actually changes, so a pick made inside the
  // bundle is never overwritten.
  function watchPdpVariant() {
    if (window.__ctlPdpWatch) return;
    window.__ctlPdpWatch = true;

    var lastSeen = getPdpVariantId();

    window.setInterval(function () {
      if (!section || !state) return;
      var current = getPdpVariantId();
      if (!current || String(current) === String(lastSeen)) return;
      lastSeen = current;

      var variant = findVariant(state.base.product, current);
      if (!variant || !variant.available) return;
      if (state.base.variant && String(state.base.variant.id) === String(variant.id)) return;

      state.base.variant = variant;
      refreshSide('base');
      mirrorSizeToPaired();
      refreshSide('paired');
      refreshTotal();
      updateCta();
    }, 800);
  }

  // The currency converter rewrites price nodes as they enter the page; it does
  // not watch the text of nodes already sitting there. Overwriting a price with
  // textContent alone therefore leaves the raw shop-currency amount on screen —
  // which is why picking a size used to drop the price back to dollars. Swapping
  // in a brand-new node makes every price update look like a first render, which
  // the converter does pick up.
  // Note the class list: no `buckscc-converted`, which is the converter's own
  // "already handled" marker — the cart drawer injects its prices the same way.
  function setMoney(el, cls, text) {
    if (!el) return null;
    // bucks-current is the converter's own marker. Its absence means the shopper
    // is browsing in the shop's currency, so the amount we write is already right.
    var converted = el.hasAttribute('bucks-current');
    var fresh = document.createElement('span');
    fresh.className = cls + ' money buckscc-money';
    var side = el.getAttribute('data-side');
    if (side) fresh.setAttribute('data-side', side);
    fresh.textContent = text;
    if (converted && text) maskUntilConverted(fresh);
    if (el.parentNode) el.parentNode.replaceChild(fresh, el);
    return fresh;
  }

  // Holds the shop-currency amount off screen until the converter has rewritten
  // it, so changing size never flashes a dollar price at a shopper browsing in
  // rupees. visibility keeps the node's box, so nothing shifts around it, and it
  // always reveals in the end — a price can't stay hidden if the app goes quiet.
  function maskUntilConverted(node) {
    node.style.visibility = 'hidden';
    var startedAt = Date.now();
    var timer = window.setInterval(function () {
      if (node.hasAttribute('bucks-current') || Date.now() - startedAt > 2000) {
        window.clearInterval(timer);
        node.style.visibility = '';
      } else if (!node.parentNode) {
        window.clearInterval(timer);
      }
    }, 40);
  }

  // The converter sweeps span.money a handful of times just after page load and
  // then stops — it never watches the DOM — so anything we inject afterwards
  // keeps its raw shop-currency amount until we ask for another sweep.
  // bucksCC.reConvert() is that entry point; it reads the shopper's currency
  // itself and skips nodes it has already handled. Calls are coalesced because
  // one size click refreshes both cards and the total.
  var currencyTimer = null;
  function refreshCurrency() {
    window.clearTimeout(currencyTimer);
    currencyTimer = window.setTimeout(function () {
      try {
        var cc = window.bucksCC;
        if (!cc) return;
        if (typeof cc.reConvert === 'function') cc.reConvert();
        else if (typeof cc.rerender === 'function') cc.rerender();
      } catch (e) {}
    }, 30);
  }

  function fetchProduct(handle) {
    return fetch('/products/' + encodeURIComponent(handle) + '.js', {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin'
    }).then(function (r) {
      if (!r.ok) throw new Error('Failed to load product: ' + handle);
      return r.json();
    });
  }

  function isRenderable(product) {
    return !!(product && Array.isArray(product.variants) && product.variants.length);
  }

  function getFirstAvailableVariant(product) {
    for (var i = 0; i < product.variants.length; i++) {
      if (product.variants[i].available) return product.variants[i];
    }
    return null;
  }

  function findVariant(product, id) {
    for (var i = 0; i < product.variants.length; i++) {
      if (String(product.variants[i].id) === String(id)) return product.variants[i];
    }
    return null;
  }

  // Size labels are compared loosely — themes vary in casing and stray spaces
  // ("L" vs " l "), and an exact match would silently miss those.
  function normalizeSize(label) {
    return String(label == null ? '' : label).trim().toUpperCase().replace(/\s+/g, ' ');
  }

  function findVariantByLabel(product, label, sizeIdx) {
    var want = normalizeSize(label);
    if (!want) return null;
    for (var i = 0; i < product.variants.length; i++) {
      var v = product.variants[i];
      if (v.available && normalizeSize(chipLabel(v, sizeIdx)) === want) return v;
    }
    return null;
  }

  function hasRealVariants(product) {
    if (product.variants.length > 1) return true;
    return product.variants[0].title !== 'Default Title';
  }

  function getSizeOptionIndex(product) {
    var opts = product.options || [];
    for (var i = 0; i < opts.length; i++) {
      var name = typeof opts[i] === 'string' ? opts[i] : opts[i] && opts[i].name;
      if (name && /size/i.test(name)) return i;
    }
    return opts.length ? opts.length - 1 : 0;
  }

  function chipLabel(variant, sizeIdx) {
    if (variant.options && variant.options.length) {
      var v = variant.options[sizeIdx];
      if (v && v !== 'Default Title') return v;
    }
    return variant.title && variant.title !== 'Default Title' ? variant.title : '';
  }

  function colourway(variant, sizeIdx) {
    if (!variant || !variant.options || variant.options.length <= 1) return '';
    var parts = [];
    for (var i = 0; i < variant.options.length; i++) {
      if (i !== sizeIdx && variant.options[i] && variant.options[i] !== 'Default Title') {
        parts.push(variant.options[i]);
      }
    }
    return parts.join(' / ');
  }

  function getImage(product) {
    if (product.featured_image) return product.featured_image;
    if (product.images && product.images.length) return product.images[0];
    return '';
  }

  function formatMoney(cents) {
    var amount = (cents || 0) / 100;
    var str = amount % 1 === 0 ? amount.toFixed(0) : amount.toFixed(2);
    return '$' + str;
  }

  function escapeHtml(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  // Active swatch = swatch linking to the current product; if none links to it
  // and the list was rendered for this exact product, fall back to Liquid's flag.
  function activeSwatch(entry) {
    var list = entry.swatches || [];
    var i;
    for (i = 0; i < list.length; i++) {
      if (list[i].handle === entry.product.handle) return list[i];
    }
    if (swatchMap[entry.product.handle] === list) {
      for (i = 0; i < list.length; i++) {
        if (list[i].active) return list[i];
      }
    }
    return null;
  }

  // Compare-at price for whatever is currently selected. Returns 0 when the
  // item isn't discounted, so the struck-through price stays hidden.
  function compareAt(entry) {
    var v = entry.variant;
    var compare = v && v.compare_at_price ? v.compare_at_price : 0;
    var price = v ? v.price : entry.product.price;

    if (!compare) {
      compare = entry.product.compare_at_price || 0;
      if (!compare && typeof entry.product.compare_at_price_max === 'number') {
        compare = entry.product.compare_at_price_max;
      }
    }
    return compare > price ? compare : 0;
  }

  function colourLabel(entry) {
    var act = activeSwatch(entry);
    if (act && act.name) return String(act.name).toUpperCase();
    return colourway(entry.variant || entry.product.variants[0], entry.sizeIdx).toUpperCase();
  }

  // ─── Markup builders ──────────────────────────────────────────────────────

  function buildSizePicker(side) {
    var entry = state[side];
    var product = entry.product;
    if (!hasRealVariants(product)) return '';

    var sizes = product.variants
      .map(function (variant) {
        var soldOut = !variant.available;
        var isSel = entry.variant && String(variant.id) === String(entry.variant.id);
        var label = chipLabel(variant, entry.sizeIdx);
        var cls = ['ctl-qs-size'];
        if (isSel) cls.push('is-selected');
        if (soldOut) cls.push('is-soldout');
        return (
          '<li class="ctl-qs-item">' +
            '<button type="button" class="' + cls.join(' ') + '"' +
            ' data-side="' + side + '" data-variant-id="' + variant.id + '"' +
            ' aria-pressed="' + (isSel ? 'true' : 'false') + '"' +
            ' aria-label="' + escapeHtml(label) + (soldOut ? ' (sold out)' : '') + '"' +
            (soldOut ? ' aria-disabled="true"' : '') +
            '>' + escapeHtml(label) + '</button>' +
          '</li>'
        );
      })
      .join('');

    return (
      '<button type="button" class="ctl-qs-toggle" data-side="' + side + '"' +
        ' aria-expanded="false" aria-label="Choose size for ' + escapeHtml(product.title) + '">' +
        QS_PLUS_SVG +
      '</button>' +
      '<div class="ctl-qs-popup" data-side="' + side + '">' +
        '<ul class="ctl-qs-list">' + sizes + '</ul>' +
      '</div>'
    );
  }

  // The toggle stays a plain + icon. The chosen size is recorded on the card as
  // data attributes only, so it can be checked in DevTools without showing up.
  function updateToggle(side) {
    if (!section) return;
    var entry = state[side];
    if (!entry) return;

    var node = section.querySelector('.ctl-bundle__product[data-side="' + side + '"]');
    if (!node) return;

    node.setAttribute('data-selected-size', entry.variant ? chipLabel(entry.variant, entry.sizeIdx) : '');
    node.setAttribute('data-selected-variant', entry.variant ? entry.variant.id : '');
  }

  function buildSwatches(side) {
    var entry = state[side];
    var list = entry.swatches || [];
    if (!list.length) return '';
    var act = activeSwatch(entry);

    var items = list
      .map(function (sw) {
        var href = sw.url || ('/products/' + sw.handle);
        return (
          '<a class="mp__swatch' + (sw === act ? ' mp__swatch--active' : '') + '"' +
            ' href="' + escapeHtml(href) + '"' +
            ' data-side="' + side + '" data-handle="' + escapeHtml(sw.handle) + '"' +
            ' aria-label="' + escapeHtml(sw.name) + '" title="' + escapeHtml(sw.name) + '">' +
            (sw.image
              ? '<img src="' + escapeHtml(sw.image) + '" alt="' + escapeHtml(sw.name) + '" width="80" height="80" decoding="async">'
              : '') +
          '</a>'
        );
      })
      .join('');

    return (
      '<div class="mp__swatches" data-swatches data-side="' + side + '">' +
        '<button type="button" class="mp__swatch-arrow mp__swatch-arrow--prev" aria-label="Previous colours" hidden>' + ARROW_PREV_SVG + '</button>' +
        '<div class="mp__swatch-track">' + items + '</div>' +
        '<button type="button" class="mp__swatch-arrow mp__swatch-arrow--next" aria-label="Next colours" hidden>' + ARROW_NEXT_SVG + '</button>' +
      '</div>'
    );
  }

  function buildProduct(side) {
    var entry = state[side];
    var product = entry.product;
    var img = getImage(product);
    var price = entry.variant ? entry.variant.price : product.price;
    var compare = compareAt(entry);
    var inner = BADGES[side] + buildSizePicker(side);

    var imgBlock = img
      ? '<a href="/products/' + encodeURIComponent(product.handle) + '" class="ctl-bundle__img-link">' +
          '<div class="ctl-bundle__img-wrap">' +
            '<img class="ctl-bundle__img" src="' + escapeHtml(img) + '" alt="' + escapeHtml(product.title) + '" loading="lazy">' +
            inner +
          '</div></a>'
      : '<div class="ctl-bundle__img-wrap ctl-bundle__img-wrap--empty">' + inner + '</div>';

    return [
      '<div class="ctl-bundle__product" data-side="' + side + '">',
        imgBlock,
        '<p class="ctl-bundle__product-name">' + escapeHtml(product.title.toUpperCase()) + '</p>',
        '<p class="ctl-bundle__product-variant" data-side="' + side + '">' + escapeHtml(colourLabel(entry)) + '</p>',
        '<span class="ctl-bundle__product-prices" data-side="' + side + '">' +
          '<span class="ctl-bundle__product-price ' + MONEY_CLASS + '" data-side="' + side + '">' + formatMoney(price) + '</span>' +
          // A <span>, not <s> — the currency converter only rewrites span.money,
          // so an <s> would keep showing the raw shop-currency amount.
          '<span class="ctl-bundle__product-compare ' + MONEY_CLASS + '" data-side="' + side + '"' + (compare ? '' : ' hidden') + '>' +
            (compare ? formatMoney(compare) : '') +
          '</span>' +
        '</span>',
        buildSwatches(side),
      '</div>'
    ].join('');
  }

  function namesText() {
    return state.base.product.title + ' + ' + state.paired.product.title;
  }

  // ─── Render ───────────────────────────────────────────────────────────────

  function renderBundle() {
    var existing = document.querySelectorAll('.ctl-bundle');
    for (var e = 0; e < existing.length; e++) {
      if (existing[e].parentNode) existing[e].parentNode.removeChild(existing[e]);
    }

    section = document.createElement('div');
    section.className = 'ctl-bundle';
    section.innerHTML = [
      '<div class="ctl-bundle__inner">',
        '<div class="ctl-bundle__header">',
          '<h2 class="ctl-bundle__title">' + escapeHtml(SECTION_TITLE) + '</h2>',
          '<a class="ctl-bundle__subtitle" href="' + escapeHtml(matchingSetsUrl) + '">' + escapeHtml(matchingSetsLabel) + '</a>',
        '</div>',
        '<div class="ctl-bundle__products">',
          buildProduct('base'),
          '<div class="ctl-bundle__plus" aria-hidden="true">' + PLUS_SVG + '</div>',
          buildProduct('paired'),
        '</div>',
        '<div class="ctl-bundle__footer">',
          '<div class="ctl-bundle__summary">',
            '<p class="ctl-bundle__summary-label">THE FULL SET</p>',
            '<div class="ctl-bundle__summary-row">',
              '<span class="ctl-bundle__totals">' +
                '<span class="ctl-bundle__total ' + MONEY_CLASS + '">' + formatMoney(currentTotal()) + '</span>' +
                // A <span>, not <s> — the currency converter only rewrites span.money.
                '<span class="ctl-bundle__total-compare ' + MONEY_CLASS + '"' + (currentCompareTotal() ? '' : ' hidden') + '>' +
                  (currentCompareTotal() ? formatMoney(currentCompareTotal()) : '') +
                '</span>' +
              '</span>',
              '<span class="ctl-bundle__summary-names">' + escapeHtml(namesText()) + '</span>',
            '</div>',
          '</div>',
          '<button type="button" class="ctl-bundle__cta">' + escapeHtml(DEFAULT_CTA) + '</button>',
        '</div>',
      '</div>'
    ].join('');

    insertSection(section);

    ctaBtn = section.querySelector('.ctl-bundle__cta');

    section.addEventListener('click', onSectionClick);
    section.addEventListener('keydown', onSectionKeydown);
    // scroll doesn't bubble, but it is delivered in the capture phase
    section.addEventListener('scroll', onSectionScroll, true);
    ctaBtn.addEventListener('click', addBothToCart);

    bindGlobalOnce();
    updateToggle('base');
    updateToggle('paired');
    updateCta();
    settleSwatches();
    refreshCurrency();
  }

  function rerenderSide(side) {
    var old = section && section.querySelector('.ctl-bundle__product[data-side="' + side + '"]');
    if (!old) return;
    var tmp = document.createElement('div');
    tmp.innerHTML = buildProduct(side);
    old.parentNode.replaceChild(tmp.firstElementChild, old);
    updateToggle(side);
    settleSwatches();
    refreshCurrency();
  }

  function insertSection(node) {
    var descSection = document.querySelector('section.product__description');
    if (descSection && descSection.parentNode) {
      descSection.parentNode.insertBefore(node, descSection.nextSibling);
      return;
    }
    var fallback = document.querySelector('.product__meta, .product-single, main');
    if (fallback) fallback.appendChild(node);
  }

  // ─── Swatch arrows ────────────────────────────────────────────────────────

  function updateArrows(wrap) {
    if (!wrap) return;
    var track = wrap.querySelector('.mp__swatch-track');
    var prev = wrap.querySelector('.mp__swatch-arrow--prev');
    var next = wrap.querySelector('.mp__swatch-arrow--next');
    if (!track) return;
    var overflowing = track.scrollWidth > track.clientWidth + 2;
    if (!overflowing) {
      if (prev) prev.hidden = true;
      if (next) next.hidden = true;
      return;
    }
    if (prev) prev.hidden = track.scrollLeft <= 0;
    if (next) next.hidden = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
  }

  function updateAllArrows() {
    if (!section) return;
    Array.prototype.forEach.call(section.querySelectorAll('[data-swatches]'), updateArrows);
  }

  function revealActiveSwatches() {
    if (!section) return;
    Array.prototype.forEach.call(section.querySelectorAll('[data-swatches]'), function (wrap) {
      var track = wrap.querySelector('.mp__swatch-track');
      var act = wrap.querySelector('.mp__swatch--active');
      if (!track || !act || track.scrollWidth <= track.clientWidth + 2) return;
      var offset = act.getBoundingClientRect().left - track.getBoundingClientRect().left;
      if (offset < 0 || offset + act.offsetWidth > track.clientWidth) {
        track.scrollLeft += offset - 4;
      }
    });
  }

  function settleSwatches() {
    // Show both arrows first so the track has its narrowest width, then measure
    updateAllArrows();
    window.setTimeout(function () { revealActiveSwatches(); updateAllArrows(); }, 300);
    window.setTimeout(updateAllArrows, 1200);
  }

  function onSectionScroll(e) {
    var t = e.target;
    if (t && t.classList && t.classList.contains('mp__swatch-track')) {
      updateArrows(t.closest('[data-swatches]'));
    }
  }

  // ─── Interaction ──────────────────────────────────────────────────────────

  function bindGlobalOnce() {
    if (window.__ctlBundleGlobalBound) return;
    window.__ctlBundleGlobalBound = true;

    document.addEventListener('click', function (e) {
      if (!section) return;
      if (e.target.closest && e.target.closest('.ctl-qs-toggle, .ctl-qs-popup')) return;
      closePopups();
    });

    var resizeTimer = null;
    window.addEventListener('resize', function () {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(updateAllArrows, 120);
    });
  }

  function onSectionClick(e) {
    var t = e.target;

    // Size toggle (+)
    var toggle = t.closest('.ctl-qs-toggle');
    if (toggle) {
      e.preventDefault();
      e.stopPropagation();
      togglePopup(toggle.getAttribute('data-side'));
      return;
    }

    // Size pick
    var size = t.closest('.ctl-qs-size');
    if (size) {
      e.preventDefault();
      if (size.classList.contains('is-soldout')) return;
      selectVariant(size.getAttribute('data-side'), size.getAttribute('data-variant-id'));
      closePopups();
      return;
    }

    // Taps on popup padding must not open the PDP (popup sits inside the image link)
    if (t.closest('.ctl-qs-popup')) {
      e.preventDefault();
      return;
    }

    // Swatch arrows
    var arrow = t.closest('.mp__swatch-arrow');
    if (arrow) {
      e.preventDefault();
      var wrap = arrow.closest('[data-swatches]');
      var track = wrap && wrap.querySelector('.mp__swatch-track');
      if (track) {
        track.scrollLeft += arrow.classList.contains('mp__swatch-arrow--prev') ? -SWATCH_STEP : SWATCH_STEP;
      }
      return;
    }

    // Colour swatch — left as a plain link on both cards, so it navigates to
    // that colour's PDP instead of swapping the product in place.
    var swatch = t.closest('.mp__swatch');
    if (swatch) {
      if (!SWAP_IN_PLACE) return;
      e.preventDefault();
      if (swatch.classList.contains('mp__swatch--active')) return;
      swapProduct(swatch.getAttribute('data-side'), swatch.getAttribute('data-handle'));
    }
  }

  function onSectionKeydown(e) {
    if (e.key !== 'Escape' && e.key !== 'Esc') return;
    var open = section.querySelector('.ctl-qs-popup.is-open');
    if (!open) return;
    var side = open.getAttribute('data-side');
    closePopups();
    var tog = section.querySelector('.ctl-qs-toggle[data-side="' + side + '"]');
    if (tog) tog.focus();
  }

  function togglePopup(side) {
    var pop = section.querySelector('.ctl-qs-popup[data-side="' + side + '"]');
    var tog = section.querySelector('.ctl-qs-toggle[data-side="' + side + '"]');
    if (!pop || !tog) return;
    var willOpen = !pop.classList.contains('is-open');
    closePopups();
    if (!willOpen) return;
    pop.classList.add('is-open');
    tog.classList.add('is-open');
    tog.setAttribute('aria-expanded', 'true');
  }

  function closePopups() {
    if (!section) return;
    Array.prototype.forEach.call(section.querySelectorAll('.ctl-qs-popup.is-open'), function (p) {
      p.classList.remove('is-open');
    });
    Array.prototype.forEach.call(section.querySelectorAll('.ctl-qs-toggle.is-open'), function (b) {
      b.classList.remove('is-open');
      b.setAttribute('aria-expanded', 'false');
    });
  }

  function selectVariant(side, id) {
    var entry = state[side];
    if (!entry) return;
    var variant = findVariant(entry.product, id);
    if (!variant || !variant.available) return;

    entry.variant = variant;
    refreshSide(side);

    // Changing the viewed product's size always carries over to the paired one.
    if (side === 'base') {
      mirrorSizeToPaired();
      refreshSide('paired');
    }

    refreshTotal();
    updateCta();
  }

  function refreshSide(side) {
    var entry = state[side];
    var sel = entry.variant;

    Array.prototype.forEach.call(
      section.querySelectorAll('.ctl-qs-size[data-side="' + side + '"]'),
      function (btn) {
        var isSel = sel && String(btn.getAttribute('data-variant-id')) === String(sel.id);
        btn.classList.toggle('is-selected', !!isSel);
        btn.setAttribute('aria-pressed', isSel ? 'true' : 'false');
      }
    );

    var priceEl = section.querySelector('.ctl-bundle__product-price[data-side="' + side + '"]');
    setMoney(priceEl, 'ctl-bundle__product-price', formatMoney(sel ? sel.price : entry.product.price));

    var compare = compareAt(entry);
    var compareEl = section.querySelector('.ctl-bundle__product-compare[data-side="' + side + '"]');
    compareEl = setMoney(compareEl, 'ctl-bundle__product-compare', compare ? formatMoney(compare) : '');
    if (compareEl) compareEl.hidden = !compare;

    var variantEl = section.querySelector('.ctl-bundle__product-variant[data-side="' + side + '"]');
    if (variantEl) variantEl.textContent = colourLabel(entry);

    updateToggle(side);
    refreshCurrency();
  }

  function swapProduct(side, handle) {
    var entry = state[side];
    if (!entry || !handle || swapping[side]) return;

    var prevSize = entry.variant ? chipLabel(entry.variant, entry.sizeIdx) : '';
    swapping[side] = true;
    closePopups();

    var node = section.querySelector('.ctl-bundle__product[data-side="' + side + '"]');
    if (node) node.classList.add('is-loading');

    fetchProduct(handle)
      .then(function (p) {
        if (!isRenderable(p)) throw new Error('not renderable');
        var sizeIdx = getSizeOptionIndex(p);
        entry.product = p;
        entry.sizeIdx = sizeIdx;
        // Keep the shopper's size when the new colour has it in stock. If they
        // hadn't chosen one, the new colour stays unselected too.
        entry.variant = prevSize
          ? findVariantByLabel(p, prevSize, sizeIdx)
          : (hasRealVariants(p) ? null : getFirstAvailableVariant(p));
        if (Array.isArray(swatchMap[p.handle])) entry.swatches = swatchMap[p.handle];
        if (side === 'paired' && !entry.variant) mirrorSizeToPaired();

        rerenderSide(side);
        refreshTotal();
        var namesEl = section.querySelector('.ctl-bundle__summary-names');
        if (namesEl) namesEl.textContent = namesText();
        updateCta();
      })
      .catch(function () {
        var n = section && section.querySelector('.ctl-bundle__product[data-side="' + side + '"]');
        if (n) n.classList.remove('is-loading');
      })
      .then(function () {
        swapping[side] = false;
      });
  }

  function currentTotal() {
    return (
      (state.base.variant ? state.base.variant.price : state.base.product.price) +
      (state.paired.variant ? state.paired.variant.price : state.paired.product.price)
    );
  }

  // Compare-at total for the set: each side contributes its own compare price,
  // or its normal price when that side isn't discounted. Returns 0 when neither
  // is discounted, so the struck-through total stays hidden.
  function currentCompareTotal() {
    var total = 0;
    var discounted = false;

    ['base', 'paired'].forEach(function (side) {
      var entry = state[side];
      var price = entry.variant ? entry.variant.price : entry.product.price;
      var compare = compareAt(entry);
      if (compare) discounted = true;
      total += compare || price;
    });

    return discounted ? total : 0;
  }

  function refreshTotal() {
    var totalEl = section.querySelector('.ctl-bundle__total');
    setMoney(totalEl, 'ctl-bundle__total', formatMoney(currentTotal()));

    var compareTotal = currentCompareTotal();
    var compareEl = section.querySelector('.ctl-bundle__total-compare');
    compareEl = setMoney(compareEl, 'ctl-bundle__total-compare', compareTotal ? formatMoney(compareTotal) : '');
    if (compareEl) compareEl.hidden = !compareTotal;

    refreshCurrency();
  }

  // ─── Cart ─────────────────────────────────────────────────────────────────

  function bothAvailable() {
    return !!(
      state.base.variant && state.base.variant.available &&
      state.paired.variant && state.paired.variant.available
    );
  }

  function anyAvailable(product) {
    return !!getFirstAvailableVariant(product);
  }

  function bothSellable() {
    return anyAvailable(state.base.product) && anyAvailable(state.paired.product);
  }

  // Which side still needs a size from the shopper ('' when both are chosen).
  function missingSide() {
    if (hasRealVariants(state.base.product) && !state.base.variant) return 'base';
    if (hasRealVariants(state.paired.product) && !state.paired.variant) return 'paired';
    return '';
  }

  function updateCta() {
    if (isAdding || !ctaBtn) return;

    ctaBtn.classList.remove('ctl-bundle__cta--soldout', 'ctl-bundle__cta--needs-size');

    if (!bothSellable()) {
      ctaBtn.disabled = true;
      ctaBtn.classList.add('ctl-bundle__cta--soldout');
      ctaBtn.textContent = SOLD_OUT_CTA;
      return;
    }

    if (missingSide()) {
      // Stays clickable: the click opens the size popup that is still empty.
      ctaBtn.disabled = false;
      ctaBtn.classList.add('ctl-bundle__cta--needs-size');
      ctaBtn.textContent = SELECT_SIZE_CTA;
      return;
    }

    ctaBtn.disabled = !bothAvailable();
    ctaBtn.textContent = bothAvailable() ? DEFAULT_CTA : SOLD_OUT_CTA;
  }

  function addBothToCart() {
    if (isAdding) return;

    // No size picked yet → open that product's popup instead of adding anything.
    var missing = missingSide();
    if (missing) {
      togglePopup(missing);
      var tog = section.querySelector('.ctl-qs-toggle[data-side="' + missing + '"]');
      if (tog) tog.focus();
      return;
    }

    if (!bothAvailable()) return;

    // Read the variants straight off state at click time — these are exactly the
    // ones the size buttons set, so whatever the toggles show is what goes in.
    var items = [
      { id: state.base.variant.id, quantity: 1 },
      { id: state.paired.variant.id, quantity: 1 }
    ];

    console.log('[CTL] adding', {
      base: chipLabel(state.base.variant, state.base.sizeIdx) + ' (' + state.base.variant.id + ')',
      paired: chipLabel(state.paired.variant, state.paired.sizeIdx) + ' (' + state.paired.variant.id + ')'
    });

    isAdding = true;
    ctaBtn.disabled = true;
    ctaBtn.textContent = 'ADDING...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ items: items })
    })
      .then(function (r) {
        return r.json().then(function (body) {
          if (!r.ok) throw body;
          return body;
        });
      })
      .then(function () {
        ctaBtn.textContent = 'ADDED!';
        refreshCartCount();
        showCartToast();
        resetCta(2500);
      })
      .catch(function () {
        ctaBtn.textContent = 'TRY AGAIN';
        resetCta(2500);
      });
  }

  function resetCta(delay) {
    window.setTimeout(function () {
      isAdding = false;
      updateCta();
    }, delay);
  }

  function showCartToast() {
    var loftCart = document.querySelector('loft-cart');
    if (!loftCart) return;
    try {
      loftCart.successToastVisible = true;
      window.setTimeout(function () { loftCart.successToastVisible = false; }, 3000);
    } catch (e) {}
  }

  function refreshCartCount() {
    fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var count = cart.item_count;
        var primary = document.getElementById('cart-svg-count');
        if (primary) {
          primary.textContent = count;
          primary.classList.add('cart-show');
        }
        document
          .querySelectorAll('.cart-count, .cart__count, [data-cart-count], .js-cart-count')
          .forEach(function (el) { el.textContent = count; });
      })
      .catch(function () {});
  }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();